import { KNOWN_CITY_PLACES } from './known-city-places.const';

import { Place } from '@/types/google-maps.types';

export const defaultPlace: Place[] = [
  KNOWN_CITY_PLACES['curitiba-pr'],
  KNOWN_CITY_PLACES['sao-paulo-sp'],
  KNOWN_CITY_PLACES['florianopolis-sc'],
  KNOWN_CITY_PLACES['londrina-pr'],
  KNOWN_CITY_PLACES['maringa-pr'],
];
